import config from '../../config'
import { authHeader } from '../utils/auth-header'

export const positionService = {
  getAll
}

async function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/graphql?query={ positions {name,_id, sport{_id,name}} }`, requestOptions)
  result = await result.json()

  return result
}



// WEBPACK FOOTER //
// ./src/services/position.js